// Shared ZIP → county lookup for admin-scheduler cards that edit a person's
// location: the new-client ClientInfoCard and the returning-client
// ReturningClientFields. The host component must expose `target` (a logic.js
// person) and may listen for the emitted `zip` event to refresh the timezone
// and eligible-advisor pool.
import { COPY } from './copy'

export default {
    computed: {
        needsCountyConfirm () {
            return this.target.counties.length > 1 && !this.target.fips
        },
        countyWarn () {
            return this.needsCountyConfirm
        },
        countyText () {
            if (this.needsCountyConfirm) return COPY.s2.countyCrossWarn
            if (this.target.county) return this.target.county
            return ''
        },
    },
    methods: {
        set (key, val) {
            this.$set(this.target, key, val)
        },
        async onZip (raw) {
            const zip = (raw || '').replace(/\D/g, '')
            this.set('zip_code', zip)
            this.set('fips', null)
            this.set('county', null)
            this.set('counties', [])
            this.set('state', null)
            if (zip.length !== 5) return
            let resp
            try {
                resp = await this.$api.getCountiesForZip(zip)
            } catch (e) {
                this.$alert({ message: COPY.s2.countyLookupFailed, variant: 'warning' })
                return
            }
            const counties = (resp && resp.counties) || []
            this.set('counties', counties)
            if (counties.length === 1) {
                this.applyCounty(counties[0])
            }
            this.$emit('zip', zip)
        },
        confirmCounty (fips) {
            const c = this.target.counties.find(x => String(x.fips) === String(fips))
            if (c) this.applyCounty(c)
        },
        applyCounty (c) {
            this.set('fips', c.fips)
            this.set('county', `${c.county || c.name}, ${c.state}`)
            // The agents endpoint filters by unexpired BrokerLicense per state —
            // without this, bookings skip the licensing filter.
            this.set('state', c.state || null)
        },
    },
}
